(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mtc"]) return;
  try {
    
  /*
   * Fix: sticky header stuck in 'idle' (opacity 0) when fast-scrolling back to top with trackpad.
   * Root cause: IntersectionObserver sets #offscreen=false before scroll events can transition
   * stickyState through 'active', so the scroll handler's early-return gate fires and stickyState
   * stays 'idle' permanently. Resetting to 'inactive' when scrollTop reaches 0 unblocks it.
   */
  (function () {
    const header = document.getElementById('header-component');
    if (!header || header.getAttribute('sticky') !== 'scroll-up') return;

    document.addEventListener(
      'scroll',
      function () {
        if (header.dataset.stickyState === 'idle' && (document.scrollingElement?.scrollTop ?? 0) <= 0) {
          header.dataset.stickyState = 'inactive';
        }
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-mtc"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
